import { render, staticRenderFns } from "./payee.vue?vue&type=template&id=752d6b38&"
import script from "./payee.vue?vue&type=script&lang=js&"
export * from "./payee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports